// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2DEkU","overflowing":"ReadFullNote_overflowing__3QVmo"};